import React from 'react';
import PropTypes from 'prop-types';

export default function CheckCircleIcon({ width = 16, height = 17, color = '#0B8368' }) {
  return (
    <svg
      role="img"
      aria-labelledby="checkCircleIcon"
      width={width}
      height={width}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id="checkCircleIcon">Check cirlce Icon</title>
      <g id="Solid/check-circle ">
        <path
          id="Vector"
          d="M7.99967 1.83337C4.33301 1.83337 1.33301 4.83337 1.33301 8.50004C1.33301 12.1667 4.33301 15.1667 7.99967 15.1667C11.6663 15.1667 14.6663 12.1667 14.6663 8.50004C14.6663 4.83337 11.6663 1.83337 7.99967 1.83337ZM10.7997 7.36671L7.59967 10.5667C7.33301 10.8334 6.93301 10.8334 6.66634 10.5667L5.19967 9.10004C4.93301 8.83337 4.93301 8.43337 5.19967 8.16671C5.46634 7.90004 5.86634 7.90004 6.13301 8.16671L7.13301 9.16671L9.86634 6.43337C10.133 6.16671 10.533 6.16671 10.7997 6.43337C11.0663 6.70004 11.0663 7.10004 10.7997 7.36671Z"
          fill={color}
        />
      </g>
    </svg>
  );
}

CheckCircleIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};
